import React from 'react'
import Modal from '@components/Common/Modal'
import { ModalSearchClienteProps } from '@modules/viagem/interfaces/SearchClienteModal'
import TableFilial from '../Table'
import Button from '@components/Common/Button'

const ModalFilial: React.FC <ModalSearchClienteProps> = props => {

    return(

        <Modal
            {...props}
            title = "Buscar filial"
            width = "100%"
        >
            <TableFilial {...props} />
            <div className='ml-auto mt-4'>
                <Button
                    label="Fechar"
                    onClick={() => props.setOpen(false)}
                />
            </div>
        </Modal>

    )

}

export default ModalFilial